<template>
    <div>
        <ly-dialog v-model="dialogVisible" :title="loadingTitle" width="560px" :before-close="handleClose">
            <el-form :inline="false" :model="formData" :rules="rules" ref="rulesForm" label-position="right" label-width="auto">
                <el-form-item label="会员套餐名称：" prop="name">
                    <el-input type="text" v-model.trim="formData.name" placeholder="请输入会员套餐名称"></el-input>
                </el-form-item>
                <el-form-item label="展位个数：" prop="booth_nums">
                    <el-input v-model="formData.booth_nums"  placeholder="请输入展位个数" v-limitPositiveInt></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="handleClose" :loading="loadingSave">取消</el-button>
                <el-button type="primary" @click="submitData" :loading="loadingSave">确定</el-button>
            </template>
        </ly-dialog>
    </div>
</template>

<script>
    import {tcliveHousevipAdd,tcliveHousevipEdit} from "@/api/api";
    import {url} from '@/api/url'
    import LyDialog from "@/components/dialog/dialog";
    import {deepClone} from '@/utils/util'
    export default {
        components: {LyDialog},
        emits: ['refreshData'],
        name: "addModuleHouseVip",
        data() {
            return {
                dialogVisible:false,
                loadingSave:false,
                loadingTitle:'',
                formData:{
                    name:'',
                    expireday:'',
                    price:'',
                },
                rules:{
                    name: [
                        {required: true, message: '请输入会员套餐名称',trigger: 'blur'}
                    ],
                    booth_nums: [
                        {required: true, message: '请输入展位个数',trigger: 'blur'}
                    ],
                }
            }
        },
        methods:{
            handleClose() {
                this.dialogVisible=false
                this.loadingSave=false
                this.formData = {
                    name:'',
                    expireday:'',
                    price:'',
                }
            },
            addModuleFn(item,flag) {
                this.loadingTitle=flag
                this.dialogVisible=true
                if(item){
                    this.formData=deepClone(item)
                }
            },
            submitData() {
                this.$refs['rulesForm'].validate(obj=>{
                    if(obj) {
                        this.loadingSave=true
                        let param = {
                            ...this.formData
                        }
                        if(this.formData.id){
                            tcliveHousevipEdit(param).then(res=>{
                                this.loadingSave=false
                                if(res.code ==2000) {
                                    this.$message.success(res.msg)
                                    this.handleClose()
                                    this.$emit('refreshData')
                                } else {
                                    this.$message.warning(res.msg)
                                }
                            })
                        }else{
                            tcliveHousevipAdd(param).then(res=>{
                                this.loadingSave=false
                                if(res.code ==2000) {
                                    this.$message.success(res.msg)
                                    this.handleClose()
                                    this.$emit('refreshData')
                                } else {
                                    this.$message.warning(res.msg)
                                }
                            })
                        }

                    }
                })
            },
        }
    }
</script>
<style scoped>

</style>

